<template>
  <div class="order-panel-list">
    <Spinner v-if="loading" />
    <p v-if="!userHasReadPermission(PermissionTypes.AccountsPermissionTypes.invoice)">
      Invoices not accessible
    </p>
    <div v-if="!loading && userHasReadPermission(PermissionTypes.AccountsPermissionTypes.invoice)">
      <p class="text-danger font-weight-bold" v-if="loadingError">{{loadingError}}</p>

      <div v-if="!hasInvoices">No invoices yet assigned to this order</div>
      <div v-if="hasInvoices">
        <p>Invoices associated with this order:</p>
        <ItemPanelList class="mt-2">
          <ItemPanel v-for="invoice of linkedInvoices" :key="invoice.id" icon="fa-envelope-open-dollar">
            <template v-slot:title>
              <strong><LinkInvoice :id="invoice.id" name="Invoice" /></strong>
            </template>
            <template v-slot:description>
              {{invoice.sequenceNumber}}
            </template>
            <template v-slot:content>
              <ItemPanelData title="Status">
                <LabelBadge :labelClass="`label-invoice-status-${invoice.status}`">{{invoice.status | formatLookupName(InvoiceStatusTypeLookup)}}</LabelBadge>
              </ItemPanelData>
              <ItemPanelData title="Invoiced">
                {{invoice.dateInvoiceCreated | formatDateTime}}
              </ItemPanelData>
              <ItemPanelData title="Due" v-if="invoice.status == InvoiceStatusTypes.invoiced">
                {{invoice.dateDue | formatDate}}
              </ItemPanelData>
              <ItemPanelData title="Paid" v-if="invoice.status == InvoiceStatusTypes.paid">
                {{invoice.dateClosed | formatDateTime}}
              </ItemPanelData>
              <ItemPanelData title="Cancelled" v-if="invoice.status == InvoiceStatusTypes.cancelled">
                {{invoice.dateClosed | formatDateTime}}
              </ItemPanelData>
              <ItemPanelData title="Outstanding" v-if="invoice.status == InvoiceStatusTypes.invoiced">
                <strong>{{invoice.amountDue | formatCurrency}}</strong>
              </ItemPanelData>
              <ItemPanelData title="Total" v-if="invoice.status == InvoiceStatusTypes.paid">
                <strong>{{invoice.totalPrice | formatCurrency}}</strong>
              </ItemPanelData>
              <ItemPanelData title="Sent">
                <Icon v-if="invoice.isSent" icon="fa-check" iconStyle="fas" iconClass="status-approved" />
                <span v-if="!invoice.isSent">No</span>
              </ItemPanelData>
            </template>
          </ItemPanel>
        </ItemPanelList>
      </div>
    </div>
  </div>
</template>

<script>
import FormMixin from '@/mixins/form'
import { InvoiceStatusTypes, InvoiceStatusTypeLookup, OrderStatusTypes } from '@/store/types'

export default {
  name: 'OrderInvoiceList',
  mixins: [FormMixin],
  props: {
    orderId: Number,
    orderStatus: String
  },
  data() {
    return {
      loading: false,
      loadingError: '',
      linkedInvoices: []
    }
  },
  watch: {
    orderId: function() {
      this.reloadData()
    }
  },
  computed: {
    hasInvoices() {
      return this.linkedInvoices.length > 0
    }
  },
  created() {
    this.InvoiceStatusTypes = InvoiceStatusTypes
    this.InvoiceStatusTypeLookup = InvoiceStatusTypeLookup
  },
  mounted() {
    this.requestData()
  },
  methods: {
    requestData() {
      this.loadingError = ''

      this.loading = true
      this.$apiService.accountsService.getInvoiceFilteredList({ filter: { orderId: this.orderId } })
      .then(response => {
        this.linkedInvoices = response.data
      })
      .catch(err => {
        this.loadingError = this.processFormResponse(err).errorMessage
      })
      .finally(() => {
        this.loading = false
      })
    },
    reloadData() {
      this.requestData()
    }
  }


}
</script>